import React from 'react';
import PropTypes from 'prop-types';

import addIcon from 'core/assets/svg/ic-add-16px.svg';
import editIcon from 'core/assets/svg/ic-editable-16px.svg';
import icLocked from 'core/assets/svg/icLocked.svg';
import { Tooltip } from 'core/components/tooltip';
import useEditReferral from 'offer/components/header/components/edit-referral/use-edit-referral';
import { HeaderValue } from '../header-value';
import useStyles from './referred-by.styles';

const LOCKED_MESSAGE = 'Update the quote to save your changes before adding a referral.';

// Both actions open today's "Add a referrer" search. With a referrer only the pencil is clickable;
// without one the whole "Add a referral" value is. Unsaved quote edits lock both.
const ReferredBy = ({ fromCheckout, inviter, className }) => {
  const classes = useStyles();
  const { hasInviter, canAddEditReferral, isLocked, openReferralSearch } = useEditReferral({ fromCheckout, inviter });

  if (!hasInviter && !canAddEditReferral) {
    return null;
  }

  const lockedIcon = (
    <Tooltip text={LOCKED_MESSAGE} placement="right" smallIcon={{ src: icLocked }} iconSize="icon16" />
  );

  if (hasInviter) {
    return (
      <HeaderValue label="Referred by" className={className}>
        <span className={classes.name}>
          {inviter.firstName} {inviter.lastName}
        </span>
        {canAddEditReferral &&
          (isLocked ? (
            lockedIcon
          ) : (
            <button type="button" className={classes.iconButton} onClick={openReferralSearch}>
              <img src={editIcon} alt="Change referrer" className={classes.icon} />
            </button>
          ))}
      </HeaderValue>
    );
  }

  return (
    <HeaderValue label="Referred by" className={className}>
      <button type="button" className={classes.addButton} onClick={openReferralSearch} disabled={isLocked}>
        <img src={addIcon} alt="" className={classes.icon} />
        Add a referral
      </button>
      {isLocked && lockedIcon}
    </HeaderValue>
  );
};

ReferredBy.propTypes = {
  fromCheckout: PropTypes.bool.isRequired,
  inviter: PropTypes.shape({
    id: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string
  }),
  className: PropTypes.string
};

ReferredBy.defaultProps = {
  inviter: null,
  className: undefined
};

export default ReferredBy;
